module.exports = __webpack_public_path__ + "img/若依开国大典场景图v4.22812f14.png";